const defaultState = function () {
  return {
    tableSetList: [{}],
    tdLists: [],
    totalCount: 0,
    currentPage: 0,
    size: 10,
    isAndSearch: false,
    searchKeyword: '',
    searchConditions: {
      customerType: {
        type: 'MultiSelector',
        title: 'ログ種別',
        property: '',
        display: false,
        value: '',
        options: [
          { code: 1, name: '注文' },
          { code: 2, name: '注文登録' }
        ]
      }
    }
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  getDefaultState: defaultState
}
